import Input from "common/Inputs/Input";
import SearchOutlined from "@ant-design/icons/SearchOutlined";
import useInput from "utils/hooks/useInput";
import { CSSProperties, useEffect } from "react";

interface useSearchInputProps {
  placeholder?: string;
  lowerCaseValue?: boolean;
  focusOnMount?: boolean;
  style?: CSSProperties;
  onChange?: (value: string) => void;
  value?: string;
}

const useSearchInput = ({
  placeholder,
  lowerCaseValue,
  focusOnMount,
  style,
  onChange,
  value: propsValue,
  ...rest
}: useSearchInputProps): [React.JSX.Element, string | undefined] => {
  const { value, bind, ref } = useInput(
    "",
    onChange,
    undefined,
    undefined,
    propsValue
  );

  useEffect(() => {
    if (focusOnMount && ref.current) {
      ref.current.focus();
    }
  }, []);

  const searchInput = (
    <Input
      placeholder={placeholder || "Search..."}
      prefix={<SearchOutlined />}
      allowClear={true}
      ref={ref}
      {...rest}
      {...bind}
      style={style}
    />
  );

  return [searchInput, lowerCaseValue ? value.toLowerCase() : value];
};

export default useSearchInput;
